import { Action, createReducer, on } from '@ngrx/store';
import { isNil } from 'lodash';
import * as LicensesActions from './actions';
import { LicensesState, initialLicensesState } from './state';

const reducer = createReducer(
  initialLicensesState,
  on(LicensesActions.setPermissionFlags, (state, action): LicensesState => {
    return {
      ...state,
      permissionFlags: action.permissionFlags,
      permissionFlagsLoaded: true
    };
  }),
  on(LicensesActions.loadBalance, (state, action): LicensesState => {
    return {
      ...state,
      loadingBalance: isNil(state.balance)
    };
  }),
  on(LicensesActions.setBalance, (state, action): LicensesState => {
    return {
      ...state,
      balance: action.balance,
      loadingBalance: false
    };
  }),
  on(LicensesActions.setLoading, (state, action): LicensesState => {
    return {
      ...state,
      actionsInLoading: state.actionsInLoading + (action.loading ? 1 : -1)
    };
  }),
  on(LicensesActions.invalidateLicenses, (state, action): LicensesState => {
    return {
      ...state,
      isInvalidLicenses: true
    };
  }),
  on(LicensesActions.loadSubscriptionEditLink, (state, action): LicensesState => {
    return {
      ...state,
      loadingSubscriptionEditLink: isNil(state.subscriptionEditLink)
    };
  }),
  on(LicensesActions.setSubscriptionEditLink, (state, action): LicensesState => {
    return {
      ...state,
      subscriptionEditLink: action.link,
      loadingSubscriptionEditLink: false
    };
  })
);

export function licensesReducer(state: LicensesState, action: Action) {
  return reducer(state, action);
}
